/**
 * Image Section Definition
 *
 * An image display section with sizing options.
 */

export const imageSection = {
  type: 'image',
  label: 'Image',
  icon: 'Image',
  description: 'Display an image',
  category: 'section',

  defaultContent: {
    src: 'https://placehold.co/600x400?text=New+Image',
    alt: '',
    width: '300',
    height: 'auto',
    imageBorderRadius: '8',
    textAlign: 'center',
    sectionBackgroundColor: 'transparent',
    padding: { base: { top: 0, right: 0, bottom: 0, left: 0, unit: 'px' }, tablet: null, desktop: null },
    margin: { base: { top: 0, right: 0, bottom: 24, left: 0, unit: 'px' }, tablet: null, desktop: null },
  },

  settingsSchema: [
    // Content category
    {
      key: 'src',
      type: 'text',
      label: 'Image URL',
      category: 'Content',
      placeholder: 'https://example.com/image.jpg',
    },
    {
      key: 'alt',
      type: 'text',
      label: 'Alt Text',
      category: 'Content',
      placeholder: 'Description of the image',
    },

    // Size category
    {
      key: 'width',
      type: 'text',
      label: "Width (px or 'auto')",
      category: 'Size',
      placeholder: '300 or auto',
      default: '300',
    },
    {
      key: 'height',
      type: 'text',
      label: "Height (px or 'auto')",
      category: 'Size',
      placeholder: '200 or auto',
      default: 'auto',
    },
    {
      key: 'imageBorderRadius',
      type: 'number',
      label: 'Image Border Radius (px)',
      category: 'Size',
      min: 0,
      max: 100,
      default: '8',
    },

    // Style category
    {
      key: 'textAlign',
      type: 'select',
      label: 'Alignment',
      category: 'Style',
      default: 'center',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    {
      key: 'sectionBackgroundColor',
      type: 'color',
      label: 'Background Color',
      category: 'Style',
      default: 'transparent',
      allowTransparent: true,
    },

    // Section Size category
    {
      key: 'sectionWidth',
      type: 'responsiveDimension',
      label: 'Section Width',
      category: 'Section Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'sectionHeight',
      type: 'responsiveDimension',
      label: 'Section Height',
      category: 'Section Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'minWidth',
      type: 'responsiveDimension',
      label: 'Min Width',
      category: 'Section Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'minHeight',
      type: 'responsiveDimension',
      label: 'Min Height',
      category: 'Section Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'maxWidth',
      type: 'responsiveDimension',
      label: 'Max Width',
      category: 'Section Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'maxHeight',
      type: 'responsiveDimension',
      label: 'Max Height',
      category: 'Section Size',
      default: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
    },

    // Border category
    {
      key: 'sectionBorderWidth',
      type: 'number',
      label: 'Border Width',
      category: 'Border',
      min: 0,
      max: 20,
      default: 0,
    },
    {
      key: 'sectionBorderStyle',
      type: 'select',
      label: 'Border Style',
      category: 'Border',
      default: 'solid',
      options: [
        { value: 'solid', label: 'Solid' },
        { value: 'dashed', label: 'Dashed' },
        { value: 'dotted', label: 'Dotted' },
        { value: 'none', label: 'None' },
      ],
    },
    {
      key: 'sectionBorderColor',
      type: 'color',
      label: 'Border Color',
      category: 'Border',
      default: 'transparent',
    },
    {
      key: 'sectionBorderRadius',
      type: 'number',
      label: 'Border Radius',
      category: 'Border',
      min: 0,
      max: 100,
      default: 0,
    },

    // Spacing category
    {
      key: 'padding',
      type: 'responsivePadding',
      label: 'Padding',
      category: 'Spacing',
      default: { base: { top: 0, right: 0, bottom: 0, left: 0, unit: 'px' }, tablet: null, desktop: null },
    },
    {
      key: 'margin',
      type: 'responsiveMargin',
      label: 'Margin',
      category: 'Spacing',
      default: { base: { top: 0, right: 0, bottom: 24, left: 0, unit: 'px' }, tablet: null, desktop: null },
    },
  ],
};

export default imageSection;
